import axios from 'axios';

export const linePresentationApi = axios.create({
    baseURL: `${process.env.REACT_APP_BACKEND!}api/line-presentation`,
    headers: {
        'Content-Type': 'application/json'
    }
})